import * as API from './server_calls';
import { getToken } from "../prefs";

export const fetchAuthUserTransactions = async (page = 1) => {
    const token = await getToken();
    return API.get(`/transactions/?currentPage=${page}`, token, true);
};